import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import GroupingImages from "./GroupingImages/GroupingImages";
import ChatMsgHelper from "../Chat/ChatMsgHelper";
import "./LeftChat.scss";

const LeftChat = ({ msg, hour, agentName, messageType }) => {
  const [htmlReturn, setHtmlReturn] = React.useState();
  const [groupImage, setGroupImage] = React.useState();
  React.useEffect(() => {
    if (messageType === "image") {
      setGroupImage(msg.split("^^"));
    } else {
      setHtmlReturn(ChatMsgHelper.transformMessage(msg));
    }
  }, [msg]);
  return (
    <div className="leftchat-container">
      <div className="image">
        <i className="gcl-icon agent-filter" />
      </div>
      <div className="content">
        <div className="hour">
          {agentName}, {hour}
        </div>
        {messageType !== "image" ? (
          <div className="msg">{htmlReturn}</div>
        ) : (
          <div className="msg left">
            <GroupingImages
              arr={groupImage ? groupImage : []}
              orientation="left"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftChat;
